<template>
  <div>
     <div class="container-fluid my-account">
          <div class="row">
             <div class="col-md-12 page_title">
                    Account
             </div>
         </div>
         <div class="row">
         <div class="col-md-12">
         <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''"></div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
    </div>
             <div class="col-md-2 account_sidebar">
                <ul class="sidebar">
						<li class="sidebar_list active">
							<router-link :to="{ name: 'dashboard' }">Overview</router-link>
						</li>
						<li class="sidebar_list">
							<h4 class="sidebar_heading">Orders & returns</h4>
							<router-link :to="{ name: 'order' }">My Orders</router-link>
						</li>
						<li class="sidebar_list">
							<h4 class="sidebar_heading">Account</h4>
							<router-link :to="{ name: 'profile' }">Profile</router-link>
							<!-- <router-link :to="{name:'address_book'}">Saved Cards</router-link> -->
							<router-link :to="{ name: 'address_book' }">Address</router-link>
						</li>
						<li class="sidebar_list">
							<h4 class="sidebar_heading">Credits</h4>
							<router-link :to="{ name: 'StoreCredit' }"
								>WNDW Credits</router-link
							>
						</li>
					</ul>
             </div>

             <div class="col-md-10 account_detail">
                <div class="row ">
               

                
                    <div class="col-12 text-left mb-2 order_detail">

                    <h4 class="main-heading pl-4">Order Details <span v-text=" this.order_no" class="order-no"></span>
					 <!-- <button class="order-with-cod" v-if="this.showCOD == 1" @click="order_with_cod(order_id)">Reorder with <span>CASH ON DELIVERY</span></button>  -->
					 <!-- <button class="order-with-cod reorder" v-if="this.showCOD != 1" @click="reorder(order_id)">Reorder</button> -->
					 </h4>
                     <div class="shipping_detail">
                         <h4 class="pb-0">
                             Delivery Address
						</h4>
                        
                     <p class="shipping_name">
                        {{this.shipping_address.name}}
                     </p>   
                            {{this.shipping_address.address}} ,
                            {{this.shipping_address.city}}, {{this.shipping_address.state}}, {{this.shipping_address.pincode}}<br>
                    <p class="shipping_name">
                        Phone Number: {{this.shipping_address.phone}}
                     </p>
                           
                     </div>     
                      </div>
                
                
               
                     <div class="col-12 ">
                         <!-- <div class="product_card" >
                         <div class="card_detail">
                           <img :src="products.image" />
                          <div class="cart_content">
                             <router-link to="/" >
                           {{products.name}}
                           </router-link>
                           <p>Size : {{products.size}}</p>
                           <p class="card_sold">Sold By :{{products.store}}</p>
                          </div>
                          </div>
                         <div class="card_price">
                          {{products.selling_price | formatMoney}}
                         </div>
                         <div class="card_status">
                           {{products.item_status}}
                      
                         </div>
                       </div> -->




					   <div class="newOrderWrap">
						   <div class="newOrderStatus">
							   <div class="orderIconImg mr-3">
								   <img src="/img/order-ico.png" alt="Order Icon" class="img-fluid">
								</div>
								<div class="newOrderDetails"><p  v-text="this.order_no"></p>
									<p class="orderStatus pending">
										{{products.order_status}}
									</p>
								</div>
							</div> 
							<div class="newOrderProductDetail">

								<div class="newOrderProductImg">
									 <responsive-image
            
										v-bind:desktop="`${$root.image_url_c}inside/100x100/${products.image}`"
										v-bind:tab="`${$root.image_url_c}inside/100x100/${products.image}`"
										v-bind:mobile="`${$root.image_url_c}inside/100x100/${products.image}`"
										v-bind:default_image="`${$root.image_url_c}inside/100x100/${products.image}`"
											
											
									/>
                      
								</div>
								
								<div class="newOrderProductDetailRight">
									
									<router-link :to="{ name: 'detail', 
										params: {
											pro_id: products.id_product,
											pro_url_key: products.url_key,
										},
										query: { store: products.store_id },
										}"
										class="router-link-active">
										
										{{products.name}}
									</router-link>
									<p><b>{{products.row_total | formatMoney}}</b></p>
									<p>Size : {{products.size}}</p>
									<p class="card_sold mb-0">Sold By: {{products.store}}</p>
								</div>
							</div>
						</div>
                     </div>
                   
                </div>
                </div>
             </div>
         </div>
     </div>
  
</template>

<script>
	import axios from "axios";
	 
	export default {
		name: "order-detail",
		components: {
			 

		},
		metaInfo: {
			title: "Order detail",
			meta: [
				{
					name: "description",
					content:
						"Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
				},
				{
					property: "keywords",
					content:
						"Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
				},
			],
		},
		data() {
			return {
				products: [],
				payment_method: "",
				order_no: "",
				status: "",
				total: "",
				order_date: "",
				showCOD: "",
				shipping_address: {
					name: "",
					address: "",
					pincode: "",
					city: "",
					state: "",
					phone: "",
				},
			};
		},
		methods: {
			reorder(pcart) {
				this.$root.page_loader = true;
				var form = new FormData();
				form.append("pcart", pcart);
				form.append("customer_id", this.$root.customer_id);
				form.append("customer_session", this.$root.customer_session);
				axios
					.post(this.$root.cart_api + "/order/re-order", form)
					.then((response) => {
						if (response.data.success === true) {
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_cart",
								response.data.data.pcart
							);
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_carts",
								response.data.data.cart_session
							);
							this.$root.cart_session = response.data.data.cart_session;
							this.$root.pcart = response.data.data.pcart;
							this.$root.thankyou_cart = response.data.data.pcart;
							this.$router.push("checkout.html");
							this.$root.page_loader = false;
						} else {
							window.scrollTo(0, 0);
							this.$root.page_loader = false;
							this.$root.error_message = response.data.message;
							if (
								response.data.customer_session_status == false ||
								response.data.cart_session_status == false
							) {
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_customer",
									"",
									"1y"
								);
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cs",
									"",
									"1y"
								);
								this.$root.customer_id = "";
								this.$root.customer_session = "";
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									"",
									"1y"
								);
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_carts",
									"",
									"1y"
								);
								this.$root.pcart = "";
								this.$root.cart_session = "";
								this.$root.cart_product = [];
								this.$router.push("/");
							}
						}
					})
					.catch((error) => {
						this.$root.page_loader = false;
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			order_with_cod(pcart) {
				this.$root.page_loader = true;
				this.$root.thankyou_cart = pcart;
				var form = new FormData();
				this.$root.thankyou_status = true;
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_thank",
					"true"
				);
				form.append("pcart", pcart);
				form.append("customer_id", this.$root.customer_id);
				form.append("customer_session", this.$root.customer_session);
				axios
					.post(this.$root.cart_api + "/order/cod-confirmation", form)
					.then((response) => {
						if (response.data.success === true) {
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_cart",
								response.data.data.pcart
							);
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_carts",
								response.data.data.cart_session
							);
							this.$root.cart_session = response.data.data.cart_session;
							this.$root.pcart = response.data.data.pcart;
							this.$root.thankyou_cart = response.data.data.pcart;
							this.$router.push("thankyou.html");
						} else {
							this.$root.page_loader = false;
							this.$root.error_message = response.data.message;
							this.$root.thankyou_status = false;
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_thank",
								""
							);
							if (
								response.data.customer_session_status == false ||
								response.data.cart_session_status == false
							) {
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_customer",
									"",
									"1y"
								);
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cs",
									"",
									"1y"
								);
								this.$root.customer_id = "";
								this.$root.customer_session = "";
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									"",
									"1y"
								);
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_carts",
									"",
									"1y"
								);
								this.$root.pcart = "";
								this.$root.cart_session = "";
								this.$root.cart_product = [];
								this.$router.push("/");
							}
						}
					})
					.catch((error) => {
						this.$root.page_loader = false;
						this.$root.thankyou_status = false;
						$cookies.set(
							window.location.hostname.substring(10, 4) + "_thank",
							""
						);
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			get_order: function () {
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					this.$root.error_message = "";
					this.$root.success_message = "";
					this.$root.page_loader = true;
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("order_id", this.$route.query.id);
					form.append("item_id", this.$route.query.item_id);
					form.append("customer_session", this.$root.customer_session);
					axios
						.post(this.$root.cart_api + "/customer/order-details", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.page_loader = false;
								this.products = response.data.data.products[0];
								this.total = response.data.data.grand_total;
								this.payment_method = response.data.data.payment_method;
								this.order_no = response.data.data.order_increment_id;
								this.showCOD = response.data.data.showCOD;
								this.order_id = response.data.data.order_quote_id;
								this.status = response.data.data.status;
								this.order_date = response.data.data.order_date;
								this.shipping_address.name =
									response.data.data.maddress.full_name;
								this.shipping_address.address =
									response.data.data.maddress.street_address;
								this.shipping_address.pincode =
									response.data.data.maddress.pin_code;
								this.shipping_address.city = response.data.data.maddress.city;
								this.shipping_address.state = response.data.data.maddress.state;
								this.shipping_address.phone = response.data.data.maddress.phone;
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									""
								);
								this.$root.cart_product = [];
								this.$root.pcart = "";
							} else {
								this.$root.page_loader = false;
								this.$root.error_message = response.data.message;
								if (
									response.data.customer_session_status == false ||
									response.data.cart_session_status == false
								) {
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.pcart = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
									this.$router.push("/");
								}
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
		},
		mounted() {
			this.get_order();
		},
		created() {
			window.scrollTo(0, 0);
			if (this.$root.customer_id === null || this.$root.customer_id === "") {
				this.$router.push("/");
			}
			(this.$root.error_message = ""),
				(this.$root.success_message = ""),
				(this.$root.breadcrumb = "My Order"),
				(this.$root.page_loader = false);
		},
	};
</script>
